import { AppContext } from '../schema/AppContext';
import type { MiddlewareType } from '../schema/MiddlewareType';

/**
 * Use this utility to register the app action middlewares
 * @param middleware
 * @returns unregister function if successfully added
 */
export function registerMiddleware(middleware: MiddlewareType): Function {
    const middlewares = AppContext.middlewares;
    if (middlewares.includes(middleware)) {
        // no op
        return () => {};
    }

    middlewares.push(middleware);

    // return a de-register function
    return () => {
        // Since this execution can happen much after, we will recalculate the index instead of scoping it via closure
        middlewares.splice(middlewares.indexOf(middleware), 1);
    };
}
